import { connect } from 'react-redux';
import { addCustomImage, removeCustomImage } from '../../actions/custom_image';
import CustomImage from './custom_image';
import { closePanel } from '../../actions/panel';

const mapStateToProps = ({ customImage }) => customImage;

export default connect(mapStateToProps, {
  addCustomImage, removeCustomImage, closePanel
})(CustomImage);
